import glamorous from 'glamorous'

import { Props } from './Input'

import { groupCSS } from '../../../helpers/styles'

import * as colours from '../../../styles/colours'
import * as fonts from '../../../styles/typography'
import { easing } from '../../../styles/animation'

const placeholder = [
  '::-webkit-input-placeholder',
  '::-moz-placeholder',
  ':-ms-input-placeholder',
  ':-moz-placeholder',
  '::placeholder',
]

export const StyledInput = glamorous.input<Props>(
  {
    width: '100%',
    height: 45,
    padding: '11px 15px',
    border: `1px solid ${colours.mainStroke}`,
    borderRadius: 2,
    backgroundColor: colours.white,
    backgroundClip: 'padding-box',
    color: colours.basicBlMain,
    fontFamily: fonts.fontRegular,
    fontSize: 16,
    transition: `border-color 250ms ${easing.easeOut}`,
    [':hover']: {
      borderColor: colours.brandBl,
    },
    [':focus']: {
      borderColor: colours.brandBl,
      outline: 'none',
    },
    ...groupCSS(placeholder, { opacity: 0.5 }),
  },
  (props) => ({
    [props.error ? 'borderColor' : '']: `${colours.error} !important`,
  })
)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/common/Input/Input.glamorous.tsx